/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  SterWebsiteModelPortalDateSpan,
  SterWebsiteModelPortalDateSpanFromJSON,
  SterWebsiteModelPortalDateSpanFromJSONTyped,
  SterWebsiteModelPortalDateSpanToJSON,
  SterWebsiteModelPriceCompareSubCampaign,
  SterWebsiteModelPriceCompareSubCampaignFromJSON,
  SterWebsiteModelPriceCompareSubCampaignFromJSONTyped,
  SterWebsiteModelPriceCompareSubCampaignToJSON,
} from "./";

/**
 *
 * @export
 * @interface SterWebsiteModelPriceCompareCampaign
 */
export interface SterWebsiteModelPriceCompareCampaign {
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceCompareCampaign
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceCompareCampaign
   */
  operator: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SterWebsiteModelPriceCompareCampaign
   */
  channels: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceCompareCampaign
   */
  targetGroup: string;
  /**
   *
   * @type {SterWebsiteModelPortalDateSpan}
   * @memberof SterWebsiteModelPriceCompareCampaign
   */
  period: SterWebsiteModelPortalDateSpan;
  /**
   *
   * @type {Array<SterWebsiteModelPriceCompareSubCampaign>}
   * @memberof SterWebsiteModelPriceCompareCampaign
   */
  subCampaigns: Array<SterWebsiteModelPriceCompareSubCampaign>;
}

export function SterWebsiteModelPriceCompareCampaignFromJSON(
  json: any
): SterWebsiteModelPriceCompareCampaign {
  return SterWebsiteModelPriceCompareCampaignFromJSONTyped(json, false);
}

export function SterWebsiteModelPriceCompareCampaignFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPriceCompareCampaign {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: !exists(json, "id") ? undefined : json["id"],
    operator: json["operator"],
    channels: json["channels"],
    targetGroup: json["targetGroup"],
    period: SterWebsiteModelPortalDateSpanFromJSON(json["period"]),
    subCampaigns: (json["subCampaigns"] as Array<any>).map(
      SterWebsiteModelPriceCompareSubCampaignFromJSON
    ),
  };
}

export function SterWebsiteModelPriceCompareCampaignToJSON(
  value?: SterWebsiteModelPriceCompareCampaign | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    operator: value.operator,
    channels: value.channels,
    targetGroup: value.targetGroup,
    period: SterWebsiteModelPortalDateSpanToJSON(value.period),
    subCampaigns: (value.subCampaigns as Array<any>).map(
      SterWebsiteModelPriceCompareSubCampaignToJSON
    ),
  };
}
